import { camelcaseKeys } from '@/axios/helpers/converters'

import { RecipientDetail } from '@/classes/models'

export default class AcquiringDetail {
  /**
   * Create new Acquiring detail and set properties based on the given object.
   *
   * @param {Object} obj
   */
  constructor (obj) {
    Object.assign(this, camelcaseKeys(obj))

    if (typeof this.mcc6012Data !== 'undefined') {
      this.recipientDetails = new RecipientDetail(this.mcc6012Data)
    }
  }
}
